import { Ref } from 'react';
import { twMerge } from 'tailwind-merge';
import { type InputBaseProps, inputBase, inputReadOnlyBase } from './base';

type InputProps = React.HTMLProps<HTMLInputElement> &
  InputBaseProps & { ref?: Ref<HTMLInputElement> };

export const Input = ({
  intent,
  disabled,
  name,
  className,
  ref,
  ...props
}: InputProps) => {
  return (
    <input
      {...props}
      name={name}
      aria-disabled={disabled}
      ref={ref}
      disabled={disabled}
      aria-invalid={intent === 'error'}
      className={twMerge(
        inputBase({ size: 'lg', intent }),
        inputReadOnlyBase,
        className,
      )}
    />
  );
};
